// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { PERSONAL_DATA_URL, PERSONAL_DATA_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ProfileIndex } = lazily(() => import('pages/back-office/personal-data/profile'))

const profileRoutes: IRoute[] = [
  {
    path: PERSONAL_DATA_URL.PROFILE,
    component: ProfileIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: PERSONAL_DATA_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.profileData',
        accessCodes: [222],
      },
    },
  },
]

export { profileRoutes }
